import { PlanComparisonTable } from '../../components/PlanComparisonTable';

type Props = {
  selectedPlan: string;
  onPlanChange: (plan: string) => void;
  onSelectAndNext: (plan: string) => void;
  onSelectFree?: () => void;
  /** True while the Free-plan handler is in flight — disables the Free button to prevent duplicate clicks. */
  selectingFree?: boolean;
  currentPlan: string | undefined;
  /** Current currency code (e.g. 'usd', 'eur') */
  currency?: string;
  /** Called when user changes currency in the selector */
  onCurrencyChange?: (currency: string) => void;
  /** Disable currency selector (paid users with existing subscription) */
  currencyDisabled?: boolean;
  /** Minimum plan required — hides plans below this level */
  minPlanRequired?: string;
  /** Hide the Free plan bar — user is already on Free (SP45) */
  hideFreePlanOption?: boolean;
};

export function WizardStepPlan({
  selectedPlan,
  onPlanChange,
  onSelectAndNext,
  onSelectFree,
  selectingFree,
  currentPlan,
  currency,
  onCurrencyChange,
  currencyDisabled,
  minPlanRequired,
  hideFreePlanOption,
}: Props) {
  return (
    <div className="py-4">
      <PlanComparisonTable
        value={selectedPlan}
        onChange={onPlanChange}
        onSelectAndNext={onSelectAndNext}
        onSelectFree={onSelectFree}
        selectingFree={selectingFree}
        currentPlan={currentPlan}
        currency={currency}
        onCurrencyChange={onCurrencyChange}
        currencyDisabled={currencyDisabled}
        minPlanRequired={minPlanRequired}
        hideFreePlanOption={hideFreePlanOption}
      />
    </div>
  );
}
